import { createFileRoute } from '@tanstack/react-router';
import Dashboard from '@src/pages/Dashboard';

import { getLocalizedTitle } from '../title';

export const Route = createFileRoute('/_app/dashboard')({
  head: () => ({
    meta: [{ title: getLocalizedTitle('dashboard.page_title', 'Dashboard') }],
  }),
  component: Dashboard,
});
